import { Mail, Globe, MapPin, LineChart, Handshake } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";

const INQUIRIES = [
  {
    icon: LineChart,
    title: "Investor Discussions",
    desc: "We are raising a seed round to fund MVP development, market launch, and team growth. Let's connect.",
  },
  {
    icon: Handshake,
    title: "Partnership Inquiries",
    desc: "Venues, promoters, brands, and campus organizations: partnership opportunities, revenue sharing, and co-branded activations.",
  },
];

const ContactPage = () => (
  <div data-testid="page-contact" className="pt-28 sm:pt-32">
    <section className="bg-surface py-16 sm:py-24">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <Eyebrow>Contact</Eyebrow>
          <h1 className="mt-4 font-display text-3xl font-black leading-[1.08] tracking-tight text-charcoal-900 sm:text-4xl lg:text-5xl">
            Let's build together.
          </h1>
          <p className="mt-6 max-w-md text-base leading-relaxed text-steel">
            True Life Entertainment is positioned for Boston dominance and scalable growth. Reach
            out to be part of it.
          </p>

          <div className="mt-10 space-y-4">
            {INQUIRIES.map((q) => (
              <div key={q.title} data-testid={`inquiry-${q.title.split(" ")[0].toLowerCase()}`} className="flex items-start gap-5 border border-line bg-white p-6">
                <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center border border-line bg-surface text-accent">
                  <q.icon className="h-5 w-5" strokeWidth={1.8} />
                </span>
                <div>
                  <div className="font-display text-base font-bold text-charcoal-900">{q.title}</div>
                  <p className="mt-1.5 text-sm leading-relaxed text-steel">{q.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 space-y-3 border-t border-line pt-8 font-mono text-xs tracking-[0.05em] text-charcoal-900">
            <a href="mailto:info@truelifeentertainment.com" data-testid="contact-email-link" className="flex items-center gap-3 transition-colors hover:text-accent">
              <Mail className="h-4 w-4 text-accent" /> info@truelifeentertainment.com
            </a>
            <a href="mailto:hello@truelifeentertainment.com" data-testid="contact-email-alt-link" className="flex items-center gap-3 transition-colors hover:text-accent">
              <Mail className="h-4 w-4 text-accent" /> hello@truelifeentertainment.com
            </a>
            <div className="flex items-center gap-3 text-steel">
              <Globe className="h-4 w-4 text-accent" /> www.truelifeentertainment.com
            </div>
            <div className="flex items-center gap-3 text-steel">
              <MapPin className="h-4 w-4 text-accent" /> Boston, Massachusetts
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <ContactForm />
        </Reveal>
      </div>
    </section>
  </div>
);

export default ContactPage;
